import { useState } from 'react';
import { Loader2, CheckCircle, AlertCircle, KeyRound, LogOut, ShieldAlert } from 'lucide-react';
import { adminApi } from '../services/adminApi';

export default function DoiMatKhau() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [kicking, setKicking] = useState(false);
  const [kickMsg, setKickMsg] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const logoutAll = async () => {
    if (!window.confirm('Đăng xuất TẤT CẢ thiết bị khác đang đăng nhập?\n\nMáy này vẫn giữ đăng nhập bình thường.')) return;
    setKickMsg(null);
    try {
      setKicking(true);
      const res = await adminApi.logoutAllDevices();
      if (res.success) {
        setKickMsg({ type: 'success', text: 'Đã đăng xuất tất cả thiết bị khác. Máy này vẫn đang đăng nhập.' });
      } else {
        setKickMsg({ type: 'error', text: res.message || 'Thất bại' });
      }
    } catch (err) {
      setKickMsg({ type: 'error', text: (err as Error).message || 'Thất bại' });
    } finally {
      setKicking(false);
    }
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMsg(null);
    if (next.length < 6) {
      setMsg({ type: 'error', text: 'Mật khẩu mới tối thiểu 6 ký tự' });
      return;
    }
    if (next !== confirm) {
      setMsg({ type: 'error', text: 'Xác nhận mật khẩu không khớp' });
      return;
    }
    try {
      setSaving(true);
      const res = await adminApi.changePassword(current, next);
      if (res.success) {
        setMsg({ type: 'success', text: 'Đổi mật khẩu thành công' });
        setCurrent('');
        setNext('');
        setConfirm('');
      } else {
        setMsg({ type: 'error', text: res.message || 'Đổi mật khẩu thất bại' });
      }
    } catch (err) {
      setMsg({ type: 'error', text: (err as Error).message || 'Đổi mật khẩu thất bại' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-container" style={{ maxWidth: 520 }}>
      <div className="page-head">
        <div>
          <h2 className="page-title">Đổi mật khẩu</h2>
          <p className="page-subtitle">Cập nhật mật khẩu đăng nhập admin</p>
        </div>
      </div>

      <div className="card card-pad">
        {msg && (
          <div className={`alert ${msg.type === 'success' ? 'alert-success' : 'alert-error'}`}>
            {msg.type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
            {msg.text}
          </div>
        )}
        <form onSubmit={submit}>
          <div className="field">
            <label className="field-label">Mật khẩu hiện tại</label>
            <input className="input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" />
          </div>
          <div className="field">
            <label className="field-label">Mật khẩu mới</label>
            <input className="input" type="password" value={next} onChange={(e) => setNext(e.target.value)} required autoComplete="new-password" />
          </div>
          <div className="field">
            <label className="field-label">Xác nhận mật khẩu mới</label>
            <input className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" />
          </div>
          <button className="btn btn-primary" disabled={saving}>
            {saving ? <Loader2 size={18} className="spin" /> : <KeyRound size={18} />} Đổi mật khẩu
          </button>
        </form>
      </div>

      {/* Bảo mật phiên đăng nhập */}
      <div className="card card-pad" style={{ marginTop: 20, borderColor: '#fecaca' }}>
        <div className="row" style={{ alignItems: 'flex-start', marginBottom: 12 }}>
          <div
            style={{
              width: 40, height: 40, borderRadius: 10, background: '#fee2e2',
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}
          >
            <ShieldAlert size={20} style={{ color: 'var(--red-600)' }} />
          </div>
          <div>
            <h3 style={{ fontWeight: 600, color: 'var(--slate-800)' }}>Bảo mật phiên đăng nhập</h3>
          </div>
        </div>

        {kickMsg && (
          <div className={`alert ${kickMsg.type === 'success' ? 'alert-success' : 'alert-error'}`}>
            {kickMsg.type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
            {kickMsg.text}
          </div>
        )}

        <button className="btn btn-danger" onClick={logoutAll} disabled={kicking}>
          {kicking ? <Loader2 size={18} className="spin" /> : <LogOut size={18} />} Đăng xuất tất cả thiết bị
        </button>
      </div>
    </div>
  );
}
